import styled from 'styled-components';
import BarSvg from '../../assets/amenities/bar.svg';

const BarIcon = styled(BarSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default BarIcon;
